import zhijiaotong from "./zhijiaotong";
import point from "./point";
import content from "./content";
import attendance from "./attendance";
import archive from "./archive";
import approval from "./approval";

/**
 * 华博特项目接口文档
 */
export default {
  zhijiaotong,
  point,
  content,
  attendance,
  archive,
  approval,
};
